import { DatiDepositoDTO } from "./dati-deposito-dto";
import { EnteRichiedenteCauzioneDTO } from "./ente-richiedente-cauzione-dto";

export class CostituzioneDepositoCauzionaleDTO {
	datiDeposito: DatiDepositoDTO;
	enteRichiedenteCauzione: EnteRichiedenteCauzioneDTO;
}